import { render, staticRenderFns } from "./createdWhiteboard.vue?vue&type=template&id=207cf6e1&scoped=true"
import script from "./createdWhiteboard.vue?vue&type=script&lang=js"
export * from "./createdWhiteboard.vue?vue&type=script&lang=js"
import style0 from "./createdWhiteboard.vue?vue&type=style&index=0&id=207cf6e1&prod&scoped=true&lang=css"
import style1 from "./createdWhiteboard.vue?vue&type=style&index=1&id=207cf6e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207cf6e1",
  null
  
)

export default component.exports